var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircleGray600(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81455 2.8145C4.14091 1.48817 5.97515 0.666626 8 0.666626C10.0248 0.666626 11.8591 1.48817 13.1854 2.81451L12.714 3.28591L13.1854 2.81451C14.5118 4.14087 15.3333 5.97511 15.3333 7.99996C15.3333 10.0248 14.5118 11.8591 13.1854 13.1854C11.8591 14.5117 10.0248 15.3333 8 15.3333C5.97515 15.3333 4.1409 14.5117 2.81455 13.1854L3.28595 12.714L2.81454 13.1854C1.48821 11.8591 0.666664 10.0248 0.666664 7.99996C0.666664 5.97511 1.48821 4.14087 2.81454 2.81451L2.81455 2.8145ZM8 1.99996C6.34298 1.99996 4.84389 2.6708 3.75735 3.75732C2.67083 4.84386 2 6.34294 2 7.99996C2 9.65698 2.67084 11.1561 3.75736 12.2426C4.84389 13.3291 6.34298 14 8 14C9.65702 14 11.1561 13.3291 12.2426 12.2426C13.3291 11.1561 14 9.65698 14 7.99996C14 6.34294 13.3292 4.84385 12.2426 3.75732C11.1561 2.6708 9.65702 1.99996 8 1.99996Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.66663C8.46023 3.66663 8.83333 4.03973 8.83333 4.49996C8.83333 4.96019 8.46023 5.33329 8 5.33329C7.53976 5.33329 7.16666 4.96019 7.16666 4.49996C7.16666 4.03973 7.53976 3.66663 8 3.66663Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83334 6.66667C6.83334 6.29848 7.13181 6 7.5 6H8.16667C8.53486 6 8.83334 6.29848 8.83334 6.66667V11.3333C8.83334 11.7015 8.53486 12 8.16667 12C7.79848 12 7.5 11.7015 7.5 11.3333V7.33333C7.13181 7.33333 6.83334 7.03486 6.83334 6.66667Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33334 11.3333C6.33334 10.9651 6.63181 10.6666 7 10.6666H9.33334C9.70153 10.6666 10 10.9651 10 11.3333C10 11.7015 9.70153 12 9.33334 12H7C6.63181 12 6.33334 11.7015 6.33334 11.3333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleGray600);
export default __webpack_public_path__ + "static/media/info_circle_gray600.9c41702495582d23ab87a17f03a9e66d.svg";
export { ForwardRef as ReactComponent };